export type ServerSide = boolean;

export const SET_SERVER_SIDE = 'SET_SERVER_SIDE';
